import { registerPlugin } from '@capacitor/core'

/** Native only; in a browser the page uses WebAuthn directly. */
export const KlunkersPasskeys = registerPlugin('KlunkersPasskeys')
